import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../styles/NavLink.scss';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng).then(() => {
      localStorage.setItem('i18nextLng', lng);
    });
  };

  const handleNavigation = (e: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    e.preventDefault();
    navigate(path);
    setExpanded(false); // Close navbar after navigation
  };

  const isActive = (path: string) => {
    return location.pathname === path ? 'nav-link-active' : '';
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Navbar
      expand="lg"
      fixed="top"
      expanded={expanded}
      onToggle={(expanded) => setExpanded(expanded)}
      className={`shadow-sm transition-navbar ${scrolled ? 'navbar-bg' : 'navbar-transparent'}`}
      style={{ transition: 'background 0.3s' }}
    >
      <Navbar.Brand as={NavLink} to="/" style={{ marginLeft: '10%' }}>
        <img 
          src="/images/rl-logo.png" 
          alt="R L Co., Ltd" 
          height="40" 
          className="d-inline-block align-top"
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav" style={{ marginRight: '10%' }}>
        <Nav className="ms-auto">
          <a href="/" onClick={(e) => handleNavigation(e, '/')} className={`fw-bold nav-link ${isActive('/')}`}>
            {t('nav.home')}
          </a>
          <a href="/about" onClick={(e) => handleNavigation(e, '/about')} className={`fw-bold nav-link ${isActive('/about')}`}>
            {t('nav.about')}
          </a>
          <a href="/services" onClick={(e) => handleNavigation(e, '/services')} className={`fw-bold nav-link ${isActive('/services')}`}>
            {t('nav.services')}
          </a>
          <a href="/news" onClick={(e) => handleNavigation(e, '/news')} className={`fw-bold nav-link ${isActive('/news')}`}>
            {t('nav.news')}
          </a>
          <a href="/career" onClick={(e) => handleNavigation(e, '/career')} className={`fw-bold nav-link ${isActive('/career')}`}>
            {t('nav.career')}
          </a>
          <a href="/contact" onClick={(e) => handleNavigation(e, '/contact')} className={`fw-bold nav-link ${isActive('/contact')}`}>
            {t('nav.contact')}
          </a>
          <NavDropdown 
            title={t('nav.language')} 
            id="basic-nav-dropdown" 
            menuVariant="dark" 
            className="nav-dropdown-bg px-2 rounded-3"
          >
            <NavDropdown.Item 
              className={`dropdown-bg text-black ${i18n.language === 'km' ? 'active' : ''}`}
              onClick={() => changeLanguage('km')}
            >
              ភាសាខ្មែរ
            </NavDropdown.Item>
            <NavDropdown.Item 
              className={`dropdown-bg text-black ${i18n.language === 'en' ? 'active' : ''}`}
              onClick={() => changeLanguage('en')}
            >
              English
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header; 